// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3t4Ft","colMin":"styles_colMin__2qHQo"};